import { resolveDefaultInstallmentDivision, type PaymentOption } from '@src/domains/payments';

import type { CardFormValues } from './cardPaymentFormSchema';

type CardFormDefaultsInput = {
  paymentOption: PaymentOption | undefined;
  isForeign: boolean;
};

export const buildCardFormDefaults = ({ paymentOption, isForeign }: CardFormDefaultsInput): CardFormValues => ({
  holder: '',
  holderIdentity: isForeign ? undefined : '',
  cardNumber: '',
  securityCode: '',
  validity: '',
  installments: resolveDefaultInstallmentDivision(paymentOption),
  billingAddress: {
    zipCode: '',
    state: null,
    city: null,
    district: null,
    street: null,
    number: null,
    complement: null,
  },
});
